(function(){
  function initPdp(){
  var root = document.querySelector('[data-aweri-pdp]'); if (!root) { return; }
  if(!root) return;

  // ----- Gallery: swipe carousel + thumbnails (desktop & mobile), synced to the scroll position -----
  var track   = root.querySelector('[data-aweri-track]');
  var gSlides = track ? [].slice.call(track.querySelectorAll('[data-aweri-slide]')) : [];
  var gThumbs = [].slice.call(root.querySelectorAll('[data-aweri-thumb]'));
  var gPrev   = root.querySelector('[data-aweri-prev]');
  var gNext   = root.querySelector('[data-aweri-next]');
  var gIndex  = 0;

  function gSetActive(i){
    gIndex = i;
    gThumbs.forEach(function(t,j){ t.classList.toggle('sel', j === i); });
    if(gPrev) gPrev.hidden = i <= 0;
    if(gNext) gNext.hidden = i >= gSlides.length - 1;
    // pause a playing video when you move off its slide
    gSlides.forEach(function(s,j){ if(j !== i){ var v = s.querySelector('video'); if(v && !v.paused){ try{ v.pause(); }catch(e){} } } });
  }
  function gScrollTo(i){
    if(!track || !gSlides[i]) return;
    // Set scrollLeft directly (native smooth scrollTo no-ops on a scroll-snap:mandatory track in some engines).
    track.scrollLeft = gSlides[i].offsetLeft - track.offsetLeft;
  }
  if(track){
    var gScrollT;
    track.addEventListener('scroll', function(){
      clearTimeout(gScrollT);
      gScrollT = setTimeout(function(){
        var w = track.clientWidth || 1;
        var i = Math.max(0, Math.min(gSlides.length - 1, Math.round(track.scrollLeft / w)));
        if(i !== gIndex) gSetActive(i);
      }, 90);
    }, { passive: true });
  }
  gThumbs.forEach(function(t,i){ t.addEventListener('click', function(){ gScrollTo(i); gSetActive(i); }); });
  if(gPrev) gPrev.addEventListener('click', function(){ var i = Math.max(0, gIndex - 1); gScrollTo(i); gSetActive(i); });
  if(gNext) gNext.addEventListener('click', function(){ var i = Math.min(gSlides.length - 1, gIndex + 1); gScrollTo(i); gSetActive(i); });
  gSetActive(0);

  // ----- Lightbox (images only): pinch / double-tap / wheel zoom, drag to pan, swipe / arrows / thumbs to navigate -----
  var lb = root.querySelector('[data-aweri-lb]');
  var imgSlides = gSlides.filter(function(s){ return s.getAttribute('data-type') === 'image'; });
  if(lb && imgSlides.length){
    var lbImg    = lb.querySelector('[data-aweri-lb-img]');
    var lbStage  = lb.querySelector('[data-aweri-lb-stage]');
    var lbCount  = lb.querySelector('[data-aweri-lb-count]');
    var lbPrev   = lb.querySelector('[data-aweri-lb-prev]');
    var lbNext   = lb.querySelector('[data-aweri-lb-next]');
    var lbThumbs = [].slice.call(lb.querySelectorAll('[data-aweri-lb-thumb]'));
    var lbFulls  = imgSlides.map(function(s){ var im = s.querySelector('img'); return im.getAttribute('data-zoom') || im.src; });
    var lbAlts   = imgSlides.map(function(s){ var im = s.querySelector('img'); return im.alt || ''; });
    var lbIndex = 0;
    var MAXZOOM = 4;
    var st = { scale: 1, x: 0, y: 0 };

    function applyT(animate){
      lbImg.style.transition = animate ? 'transform .25s ease' : 'none';
      lbImg.style.transform = 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + st.scale + ')';
      lbImg.classList.toggle('is-zoomed', st.scale > 1.01);
    }
    function clampPan(){
      var maxX = Math.max(0, (lbImg.offsetWidth  * st.scale - lbImg.offsetWidth)  / 2);
      var maxY = Math.max(0, (lbImg.offsetHeight * st.scale - lbImg.offsetHeight) / 2);
      st.x = Math.max(-maxX, Math.min(maxX, st.x));
      st.y = Math.max(-maxY, Math.min(maxY, st.y));
    }
    function resetT(animate){ st.scale = 1; st.x = 0; st.y = 0; applyT(animate); }
    function zoomTo(scale, animate){
      st.scale = Math.max(1, Math.min(MAXZOOM, scale));
      if(st.scale <= 1.01){ st.x = 0; st.y = 0; } else { clampPan(); }
      applyT(animate);
    }
    function zoomAtPoint(px, py){               // zoom in to 2.5x keeping the tapped point fixed
      var r = lbImg.getBoundingClientRect();
      st.scale = 2.5;
      st.x = (r.left + r.width / 2 - px) * (st.scale - 1);
      st.y = (r.top + r.height / 2 - py) * (st.scale - 1);
      clampPan(); applyT(true);
    }

    function lbShow(i){
      lbIndex = Math.max(0, Math.min(lbFulls.length - 1, i));
      resetT(false);
      lbImg.src = lbFulls[lbIndex]; lbImg.alt = lbAlts[lbIndex];   // hi-res (2048) source loads here
      if(lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + lbFulls.length;
      if(lbPrev) lbPrev.hidden = lbIndex <= 0;
      if(lbNext) lbNext.hidden = lbIndex >= lbFulls.length - 1;
      lbThumbs.forEach(function(t,j){ t.classList.toggle('sel', j === lbIndex); });
      // Item 2 (bug B): preload the adjacent hi-res images so prev/next renders instantly, not a fresh fetch.
      [lbIndex - 1, lbIndex + 1].forEach(function(j){ if(j >= 0 && j < lbFulls.length){ var pi = new Image(); pi.src = lbFulls[j]; } });
    }
    // Items 21+28: scroll lock / ESC / focus trap / focus return / bfcache reset come from the shared
    // AweriModal contract; only the lightbox-specific arrow behaviour (pan zoomed / navigate) stays here.
    function lbOpen(i){
      lbShow(i);
      lb.hidden = false; lb.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', lbKey);
      if(window.AweriModal) AweriModal.open('pdp-lightbox', { panel: lb, initialFocus: lb.querySelector('[data-aweri-lb-close]'), onClose: lbHide });
    }
    function lbHide(){
      lb.hidden = true; lb.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', lbKey);
    }
    function lbClose(){
      if(window.AweriModal) AweriModal.close('pdp-lightbox');
      else lbHide();
    }
    function lbKey(e){
      if(e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown'){
        if(st.scale > 1.01){                                 // C14f: arrow keys PAN the zoomed image
          e.preventDefault();
          if(e.key === 'ArrowLeft'){ st.x += 60; } else if(e.key === 'ArrowRight'){ st.x -= 60; }
          else if(e.key === 'ArrowUp'){ st.y += 60; } else { st.y -= 60; }
          clampPan(); applyT(true);
        } else {                                             // not zoomed: navigate prev/next
          if(e.key === 'ArrowLeft'){ lbShow(lbIndex - 1); } else if(e.key === 'ArrowRight'){ lbShow(lbIndex + 1); }
        }
      }
    }

    imgSlides.forEach(function(s){ s.addEventListener('click', function(){ lbOpen(parseInt(s.getAttribute('data-lb'), 10) || 0); }); });
    lbThumbs.forEach(function(t,i){ t.addEventListener('click', function(e){ e.stopPropagation(); lbShow(i); }); });
    if(lbPrev) lbPrev.addEventListener('click', function(e){ e.stopPropagation(); lbShow(lbIndex - 1); });
    if(lbNext) lbNext.addEventListener('click', function(e){ e.stopPropagation(); lbShow(lbIndex + 1); });
    lb.querySelector('[data-aweri-lb-close]').addEventListener('click', lbClose);
    lb.addEventListener('click', function(e){ if(e.target === lb || e.target === lbStage) lbClose(); });

    // desktop: double-click toggles zoom; wheel zooms; drag pans
    lbImg.addEventListener('dblclick', function(e){ e.preventDefault(); if(st.scale > 1.01){ resetT(true); } else { zoomAtPoint(e.clientX, e.clientY); } });
    var wheelT;
    lbStage.addEventListener('wheel', function(e){ if(lb.hidden) return; e.preventDefault(); zoomTo(st.scale * (e.deltaY < 0 ? 1.15 : 0.87), false); }, { passive: false });
    var mDown = false, mx = 0, my = 0;
    lbImg.addEventListener('mousedown', function(e){ if(st.scale <= 1.01) return; mDown = true; mx = e.clientX; my = e.clientY; lbImg.classList.add('is-panning'); e.preventDefault(); });
    window.addEventListener('mousemove', function(e){ if(!mDown) return; st.x += e.clientX - mx; st.y += e.clientY - my; mx = e.clientX; my = e.clientY; clampPan(); applyT(false); });
    window.addEventListener('mouseup', function(){ if(mDown){ mDown = false; lbImg.classList.remove('is-panning'); } });

    // touch: 2-finger pinch zoom, 1-finger pan (zoomed) / swipe navigate (not zoomed), double-tap zoom
    var tx0 = 0, ty0 = 0, tMoved = false, pinchD0 = 0, pinchS0 = 1, lastTap = 0, px0 = 0, py0 = 0;
    function dist(t){ var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
    lbImg.addEventListener('touchstart', function(e){
      if(e.touches.length === 2){ pinchD0 = dist(e.touches); pinchS0 = st.scale; }
      else if(e.touches.length === 1){
        tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; tMoved = false; px0 = st.x; py0 = st.y;
        var now = Date.now();
        if(now - lastTap < 300){ if(st.scale > 1.01){ resetT(true); } else { zoomAtPoint(tx0, ty0); } lastTap = 0; }
        else { lastTap = now; }
      }
    }, { passive: true });
    lbImg.addEventListener('touchmove', function(e){
      if(e.touches.length === 2 && pinchD0){ e.preventDefault(); zoomTo(pinchS0 * (dist(e.touches) / pinchD0), false); }
      else if(e.touches.length === 1 && st.scale > 1.01){ e.preventDefault(); st.x = px0 + (e.touches[0].clientX - tx0); st.y = py0 + (e.touches[0].clientY - ty0); clampPan(); applyT(false); tMoved = true; }
      else if(e.touches.length === 1){ if(Math.abs(e.touches[0].clientX - tx0) > 8) tMoved = true; }
    }, { passive: false });
    lbImg.addEventListener('touchend', function(e){
      if(pinchD0 && e.touches.length < 2){ pinchD0 = 0; if(st.scale <= 1.01) resetT(true); }
      if(st.scale <= 1.01 && tMoved){ var dx = e.changedTouches[0].clientX - tx0; if(Math.abs(dx) > 50) lbShow(dx < 0 ? lbIndex + 1 : lbIndex - 1); }
    }, { passive: true });
  }

  // State
  var idInput   = root.querySelector('[data-aweri-id]');
  var priceEl   = root.querySelector('[data-aweri-price]');
  var compareEl = root.querySelector('[data-aweri-compare]');
  var stickyEl  = root.querySelector('[data-aweri-sticky-price]');
  var stickyPackEl = root.querySelector('[data-aweri-sticky-pack]');
  var addLabel  = root.querySelector('[data-aweri-add-label]');
  var addBtn    = root.querySelector('[data-aweri-add]');
  var qtyInput  = root.querySelector('[data-aweri-qty-input]');
  var addText   = root.dataset.addLabel || 'Add to cart';
  var soldText  = root.dataset.soldLabel || 'Sold out';

  var fmt = new Intl.NumberFormat('en-IN', { style:'currency', currency: root.dataset.currency || 'INR', maximumFractionDigits: 2, minimumFractionDigits: 0 });
  function money(cents){ return fmt.format(cents/100).replace(/ /g,' '); }

  var selected = null;

  function qty(){ var q = parseInt(qtyInput && qtyInput.value, 10); return (isNaN(q) || q < 1) ? 1 : q; }

  function renderTotals(){
    if(!selected) return;
    var cents = parseInt(selected.getAttribute('data-price'), 10);
    var avail = selected.getAttribute('data-available') === 'true';
    var unit  = selected.getAttribute('data-price-money');
    if(priceEl) priceEl.textContent = unit;
    if(compareEl){
      var c = parseInt(selected.getAttribute('data-compare'), 10);
      if(c > cents){ compareEl.textContent = selected.getAttribute('data-compare-money'); compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    var total = money(cents * qty());
    if(stickyEl) stickyEl.textContent = total;
    if(stickyPackEl){ var pb = selected.querySelector('b'); if(pb) stickyPackEl.textContent = pb.textContent.trim(); }
    if(addBtn){ addBtn.disabled = !avail; }
    if(addLabel){ addLabel.textContent = avail ? (addText + ' · ' + total) : soldText; }
  }

  function select(card){
    if(!card || card.getAttribute('data-available') !== 'true') return;
    selected = card;
    // Mirror the native :checked onto .sel for the JS-path / :has-less CSS fallback (the real radio drives :has).
    root.querySelectorAll('[data-aweri-variant]').forEach(function(x){ x.classList.toggle('sel', x === card); });
    if(idInput) idInput.value = card.getAttribute('data-id');   // single-variant hidden-input fallback only; the radios carry name="id" natively
    renderTotals();
    // Variant image: scroll the gallery to this pack's resolved media slide. data-media-id is pre-resolved in
    // Liquid via snippets/aweri-variant-media (variant image -> first variant -> featured), the SAME chain the
    // card uses; here we map that media id to its slide and scroll. No match (imageless, or media beyond the
    // 8-slide cap) = leave the gallery where it is.
    var mediaId = card.getAttribute('data-media-id');
    if(mediaId){
      for(var gi = 0; gi < gSlides.length; gi++){
        if(gSlides[gi].getAttribute('data-media-id') === mediaId){ gScrollTo(gi); gSetActive(gi); break; }
      }
    }
  }

  // FLOW-02: packs are REAL radios now - selection fires on the native `change` (label click or keyboard). Native
  // radios own Arrow/Space movement + roving focus, so the old hand-rolled keydown + tabindex management is gone.
  root.querySelectorAll('[data-aweri-variant]').forEach(function(card){
    var radio = card.querySelector('.aweri-pdp__size-input');
    if(radio){
      radio.addEventListener('change', function(){ if(radio.checked){ select(card); } });
      if(radio.checked){ selected = card; }
    } else {
      card.addEventListener('click', function(){ select(card); });   // defensive: no real radio present (should not happen)
      if(card.classList.contains('sel')){ selected = card; }
    }
  });

  // O10: the dark "best" chip reads "Best . Rs X off"; if it's wider than its pill (so it would collide with a
  // neighbour chip), drop the "Best ." prefix - the dark colour alone still carries "best". Re-checked on resize.
  function fitBestChips(){
    root.querySelectorAll('.aweri-pdp__size .aweri-chip--best[data-full]').forEach(function(chip){
      var t = chip.querySelector('.aweri-chip__t'); if(!t) return;
      t.textContent = chip.getAttribute('data-full');
      // the band is full pill width now; shorten "Best . Rs X off" -> "Rs X off" only if the text overflows it.
      if(t.scrollWidth > chip.clientWidth - 16){ t.textContent = chip.getAttribute('data-short'); }
    });
  }
  fitBestChips();
  window.addEventListener('resize', fitBestChips);
  // Re-fit once webfonts load - a fallback-font measurement during boot can otherwise leave "Best ." wrongly dropped.
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitBestChips); }

  root.querySelectorAll('[data-aweri-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var step = parseInt(btn.getAttribute('data-aweri-qty'), 10);
      qtyInput.value = Math.max(1, qty() + step);
      renderTotals();
    });
  });
  if(qtyInput) qtyInput.addEventListener('change', renderTotals);

  // Out-of-stock: sticky "Notify me" jumps to the capture form.
  var notifyJump = root.querySelector('[data-aweri-notify-jump]');
  if(notifyJump){
    notifyJump.addEventListener('click', function(){
      var box = root.querySelector('[data-aweri-notify]');
      var email = root.querySelector('[data-aweri-notify-email]');
      if(box) box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
      if(email) setTimeout(function(){ email.focus(); }, 320);
    });
  }

  renderTotals();

  // ----- In-buybox pincode delivery estimate -----
  // Real serviceability + EDD via a public Google Sheet (gviz) - the SAME source the live store uses,
  // read BY COLUMN POSITION (A=pincode lookup, B=district, C=state, D=delivery days; the EDD is derived
  // from D). Reordering the sheet's columns silently breaks the read. Falls back to a rough estimate
  // if no sheet is configured or the lookup fails, so the field is never dead.
  var pinEl = root.querySelector('[data-aweri-pin]');
  var pinBtn = root.querySelector('[data-aweri-pin-check]');
  var pinInput = root.querySelector('[data-aweri-pin-input]');
  var pinRes = root.querySelector('[data-aweri-pin-res]');
  if(pinBtn && pinInput && pinRes){
    var pinCodTail = root.dataset.cod ? ' · COD available' : '';
    function pinShow(color, html){ pinRes.style.color = color; pinRes.innerHTML = html; }
    // escape any sheet-derived text so innerHTML only ever holds our own fixed tags (defence-in-depth)
    // CODE-02: uses the shared window.AweriEscapeHtml (assets/aweri-util.js, loaded first); inline fallback only if that asset failed to load.
    function pinEsc(s){ return window.AweriEscapeHtml ? window.AweriEscapeHtml(s) : String(s == null ? '' : s).replace(/[<>&"]/g, function(ch){ return { '<':'&lt;', '>':'&gt;', '&':'&amp;', '"':'&quot;' }[ch]; }); }
    function pinEDD(days){
      var t = new Date(); t.setDate(t.getDate() + (parseInt(days,10) || 0));
      return t.getDate() + ' ' + t.toLocaleString('default', { month: 'short' });
    }
    function pinHeuristic(p){
      // LEGAL-01: cap the heuristic FALLBACK to the "1-5 days" brand window (d 1-4 -> "1-2".."4-5"). The real
      // Google-Sheet lookup path is unchanged - it shows the true per-pincode days. This is only the no-data estimate.
      var d = 1 + (parseInt(p[0],10) % 4);
      pinShow('var(--aweri-green-deep)', 'Good news - we deliver to ' + p + ', in about ' + d + '-' + (d+1) + ' days' + pinCodTail + '.');
    }
    function pinCheck(){
      var p = (pinInput.value || '').replace(/\s/g,'');
      if(!/^[1-9]\d{5}$/.test(p)){ pinShow('var(--aweri-tomato-deep)', 'Enter a valid 6-digit pincode.'); return; }
      var sheet = pinEl && pinEl.getAttribute('data-sheet');
      var sheetName = (pinEl && pinEl.getAttribute('data-sheet-name')) || 'Aweri';
      if(!sheet){ pinHeuristic(p); return; }
      pinBtn.disabled = true;
      pinBtn.classList.add('is-loading');  // spinner on the Check button (replaces the "Checking..." text line)
      pinShow('', '');
      var q = encodeURIComponent('select B,C,D,E,F where A =' + p);
      var url = 'https://docs.google.com/spreadsheets/d/' + sheet + '/gviz/tq?&sheet=' + encodeURIComponent(sheetName) + '&tq=' + q;
      // RESIL-06: a hung gviz request must never strand the spinner. Abort after 7s; the rejection lands in
      // .catch() (the heuristic fallback), and .finally() always clears the loading state - success, error, OR timeout.
      var pinAbort = new AbortController();
      var pinTimer = setTimeout(function(){ pinAbort.abort(); }, 7000);
      fetch(url, { signal: pinAbort.signal }).then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(txt){
        var data = JSON.parse(txt.substring(txt.indexOf('(') + 1, txt.lastIndexOf(')')));
        var rows = data.table && data.table.rows;
        if(!rows || !rows.length || !rows[0].c[0]){
          pinShow('var(--aweri-tomato-deep)', "We don't deliver to " + p + " just yet - <a style='text-decoration:underline;color:inherit;' href='" + (root.dataset.contactUrl || '/pages/contact') + "'>tell us</a> and we'll try to help.");
          return;
        }
        var c = rows[0].c;
        var district = c[0] && c[0].v ? c[0].v : '';
        var state = c[1] && c[1].v ? c[1].v : '';
        var days = (c[2] && c[2].v != null) ? c[2].v : null;
        // Drop a redundant state when the district already names it (e.g. "Central Delhi, Delhi" -> "Central Delhi").
        var showState = state && district && district.toLowerCase().indexOf(state.toLowerCase()) === -1;
        var where = district ? pinEsc(district + (showState ? ', ' + state : '')) : ('pincode ' + p);
        if(days != null && parseInt(days,10) === 0){ pinShow('var(--aweri-green-deep)', 'Congrats! &#127881; Order now and get it <b>today</b> at ' + where + pinCodTail + '.'); }
        else if(days != null){ pinShow('var(--aweri-green-deep)', 'Congrats! &#127881; You\'ll get your order at ' + where + ' by <b>' + pinEDD(days) + '</b> if you order now' + pinCodTail + '.'); }
        else { pinShow('var(--aweri-green-deep)', 'Good news - we deliver to ' + where + pinCodTail + '.'); }
      }).catch(function(){ pinHeuristic(p); }).finally(function(){ clearTimeout(pinTimer); pinBtn.disabled = false; pinBtn.classList.remove('is-loading'); });
    }
    pinBtn.addEventListener('click', pinCheck);
    pinInput.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); pinCheck(); } });
  }

  // Sticky buy bar: show ONLY after the in-page Add-to-cart scrolls out of view (Baymard), and lift the
  // floating cart / back-to-top above it via html.aweri-has-buybar. Mobile only (the bar is mobile-only).
  var stickyBar = root.querySelector('.aweri-pdp__sticky');
  var stickyAnchor = addBtn || root.querySelector('[data-aweri-notify]') || priceEl;
  if (stickyBar && stickyAnchor) {
    var sTick = false;
    function updateSticky(){
      var show = stickyAnchor.getBoundingClientRect().bottom < 8;
      stickyBar.classList.toggle('is-visible', show);
      // lift the floating cart / back-to-top above the bar (inline = robust vs the theme's CSS cascade)
      var fc = document.querySelector('.aweri-floatcart-btn'), bt = document.querySelector('.aweri-backtop'), tt = document.getElementById('aweri-toast');
      if (fc) fc.style.bottom = show ? '88px' : '';
      if (bt) bt.style.bottom = show ? '150px' : '';
      if (tt) tt.style.bottom = show ? '88px' : '';  // keep the toast level with the lifted cart (it sits to its left)
      sTick = false;
    }
    window.addEventListener('scroll', function(){ if(sTick) return; sTick = true; requestAnimationFrame(updateSticky); }, { passive:true });
    window.addEventListener('resize', function(){ if(sTick) return; sTick = true; requestAnimationFrame(updateSticky); }, { passive:true });
    updateSticky();
  }
  }
  initPdp();
  // Theme editor only: re-init when the PDP section is re-rendered so the gallery/variant/sticky logic stays live
  // while editing. designMode-gated => zero shopper impact; the few window listeners re-bound here are idempotent.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-aweri-pdp]')) initPdp();
    });
  }
})();
